<div class="form-divider-title headline-small">{{ title.main | translate }}</div>
<ng-container *ngIf="parentReorderConfig?.items?.length">
  <div class="form-divider-title sub-title">{{ title.parent | translate }}</div>
  <app-reorder-list [disabled]="true" [config]="parentReorderConfig"></app-reorder-list>
</ng-container>

<div class="form-divider-title sub-title" *ngIf="title.child">{{ title.child | translate }}</div>
<app-reorder-list (onReorder)="onReorder($any($event))" [config]="reorderConfig"></app-reorder-list>

<div class="add-block">
  <ion-button class="page-button" (click)="selectProperties()" color="secondary">{{ "PROPERTY.Select_Adjust_Property" | translate }}</ion-button>
</div>

<ng-template let-property="item" #propertyNameRef>
  <div class="title">
    <div *ngIf="!property.propertyID" class="folder-icon"></div>
    <div *ngIf="property.propertyID" #propertyTitle [tooltip]="propertyTitle.innerHTML" class="title-value">{{property.title | translate}}</div>
    <div *ngIf="!property.propertyID" #folderTitle [tooltip]="folderTitle.innerHTML" class="title-value">{{ property.folderID ? (property.folderID | folderPath) : property.title | translate }}</div>
  </div>
</ng-template>

<ng-template let-property="item" #fullPropertyNameRef>
  <div class="title">
    <div *ngIf="property?.propertyID" class="title-value">
      <ng-container *ngIf="property.folderID">{{property.folderID | folderPath}}/</ng-container>{{property.title | translate}}
    </div>
  </div>
</ng-template>

<ng-template let-property="item" let-disabled="disabled" #propertyStateRef>
  <ion-toggle (ngModelChange)="onStateChanged($event, property)" [disabled]="disabled" [(ngModel)]="property.healthRelated" color="secondary"></ion-toggle>
</ng-template>

<ng-template let-property="item" let-disabled="disabled" #requiredRef>
  <ion-toggle (ngModelChange)="toggleRequiredValue($event, property)" [disabled]="disabled" [(ngModel)]="property.required" color="secondary"></ion-toggle>
</ng-template>

<ng-template let-property="item" let-disabled="disabled" #propertyHiddenRef>
  <ion-toggle (ngModelChange)="toggleHiddenValue($event, property)" [disabled]="disabled" [(ngModel)]="property.hidden" color="secondary"></ion-toggle>
</ng-template>

<ng-template let-property="item" let-disabled="disabled" #propertyDefaultValueRef>
  <ng-container *ngIf="property.propertyID && property.static">
    <div #propertyValue [tooltip]="propertyValue.innerHTML" class="property-value">{{ property | propertyDefaultValue }}</div>
    <ion-icon *ngIf="!disabled" (click)="changeValue(property)" src="assets/icons/custom-create-icon.svg"></ion-icon>
  </ng-container>
</ng-template>
